import { Destination, DestinationBlog } from "models/Destination";
import { GenericService, Service } from "./genericService";
import axios from "axios";

class DestinationBlogService
  extends GenericService<DestinationBlog>
  implements Service<DestinationBlog>
{
  constructor() {
    super("api/DestinationBlog");
  }

  getList = async (page: number): Promise<DestinationBlog[]> => {
    const result = await axios.get(`${this.baseUrl}/pagination?page=${page}`);
    return result.data;
  };
}

export default new DestinationBlogService();
